import { PAYMENT_OPTIONS } from 'constants/payment'
import { createSelector } from 'reselect'
import getMerchantFeeAmount from '../getMerchantFeeAmount'
import getPaymentScheduleDepositAmount from './getPaymentScheduleDepositAmount'

const getPaymentScheduleDueToday = createSelector(
  getPaymentScheduleDepositAmount,
  (state: App.State) => getMerchantFeeAmount(state, PAYMENT_OPTIONS.PAYMENT_SCHEDULE),
  (depositAmount, merchantFee): number => {
    if (depositAmount) {
      return depositAmount + merchantFee
    }
    return 0
  },
)

export default getPaymentScheduleDueToday
